import React from 'react';

import CommonNode from '../../../../components/node/common-node';
import { NodeProvider } from '../../../../context/node-context';
import { getNodeName } from '../../../../utils/getNodeName';
import CopyFileToS3TaskForm from './forms/copy-file-to-s3-task-form';
import { copyFileToS3TaskValidationSchema } from './schema.js';

export default function SftpOperationCopyFileToS3Node({ data, id, type }) {
  const nodeName = getNodeName(data?.name, 'SFTP Operation Copy File To S3 Task');

  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: nodeName,
        altText: 'SFTP Operation Copy File To S3 Task',
        defaultLabel: 'SFTP Operation Copy File To S3 Task',
      }}
    >
      <CommonNode
        FormComponent={CopyFileToS3TaskForm}
        schemaResolver={copyFileToS3TaskValidationSchema}
      />
    </NodeProvider>
  );
}
